import React from "react";
import Navbar from "./Navbar";
import analytic from "../assets/servicesbg.webp";
import Footer from "./Footer";
import { Link, NavLink } from "react-router-dom";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import icon4 from "../assets/icon4.png";
import icon5 from "../assets/icon5.png";
import icon6 from "../assets/icon6.png";
import icon7 from "../assets/icon7.png";
import icon8 from "../assets/icon8.png";
import icon from "../assets/icon.png";
import ScrollToTop from '../Components/Scroll.js'

const Services = () => {
  return (
    <>
      <Navbar></Navbar>

      <div className="relative w-full h-[300px]">
        {/* Background Image */}
        <img
          src={analytic}
          alt="About Us"
          className="w-full h-full object-cover"
        />

        {/* Centered Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center space-y-4">
          {/* Heading */}
          <h1 className="text-white text-6xl font-bold drop-shadow-md">
            Our Services
          </h1>

          {/* Contact Us Button */}
          <NavLink
            to="/Contact"
            className="button-27 border-2 border-gray-100 rounded-lg text-white cursor-pointer font-sans font-semibold text-base leading-normal px-8 py-3 outline-none transition-all duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:shadow-lg hover:-translate-y-1 active:shadow-none active:translate-y-0 disabled:pointer-events-none"
          >
            Contact Us
          </NavLink>
        </div>
      </div>

      {/* CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {/* <!-- Card 1 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Medical Billing Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                We offer customized solutions that fit your requirements
              </h1>
            </div>
          </div>
        </div>

        {/* <!-- Card 2 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon2} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Medical Coding Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Accrurate medical coding services ensure complete compliance
                with ICD-10 and CPT Standards.
              </h1>
            </div>
          </div>
        </div>

        {/* <!-- Card 3 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon3} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Prior Authorization Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Streamlined prompt prior authorixation services ensure swift
                approvals and optimum patient care.
              </h1>
            </div>
          </div>
        </div>

        {/* <!-- Card 4 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon4} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Virtual Medical Assistant
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Enhance efficiency and improve patient care by 24/7
                cost-effective virtual medical help desk.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 5 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon5} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Medical Credentialing Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Meet Industry's standards set by regulatory bodies for
                maintaining licensure and accreditation.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 6 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon6} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Denial Management Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Rapidly resolve claim denials and their timely solution to
                increase patient revenue.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 7 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon7} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Insurance Eligibilty Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Improve patient satisfaction and reduce denials effortlessly by
                using reliable verification services.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 8 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon8} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Health Care Data Analytic
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Data driven insights comprehensive reporting, enhancing patient
                outcomes, empowering informed decisions making.
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center min-h-screen bg-white">
  <div className="bg-blue-300 py-10 flex flex-col items-center justify-center text-center w-full sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w- border-4 border-gray-300 rounded-lg">
    {/* Heading */}
    <h1 className="font-bold text-3xl sm:text-4xl lg:text-5xl text-indigo-900 pt-5 break-words max-w-4xl">
      Outsource to the USA's Most Reputed Medical Billing Company Today!
    </h1>

    {/* Paragraph */}
    <p className="text-black text-lg pt-5 font-sans font-medium break-words leading-relaxed max-w-3xl">
      By hiring our billing specialists, providers get assurance of a quick
      turnaround in revenue cycle management. Our team works tirelessly on
      increasing the practice’s financial output. We help you earn more
      through a smooth billing process.
    </p>

    {/* Button */}
    <div className="mt-9">
      <NavLink
        to="/Contact"
        className="button-27 w-full max-w-xs appearance-none bg-gradient-to-r from-yellow-400 to-sky-400
        border-2 border-gray-100 rounded-lg text-white cursor-pointer font-sans font-semibold text-base leading-normal p-4 min-h-[60px] outline-none transition-all duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:shadow-lg hover:-translate-y-1 active:shadow-none active:translate-y-0 disabled:pointer-events-none"
      >
        Book Appointment Now
      </NavLink>
    </div>
  </div>
</div>



<ScrollToTop></ScrollToTop>
      <Footer></Footer>
    </>
  );
};

export default Services;
